/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({
  organizationId: ZodTypes.Id,
  projectId: ZodTypes.Id,
  clusterId: ZodTypes.Id,
});

export const GetClusterNodes = {
  id: 'cluster-nodes.get',
  tag: 'Cluster',
  summary: 'Get cluster nodes',
  description: 'Retrieve the nodes of a cluster',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) =>
    `/organization/${params.organizationId}/project/${params.projectId}/cluster/${params.clusterId}/node`,
  request: {
    params: Params,
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.array(
            z.strictObject({
              id: ZodTypes.Id,
              status: z.string().min(1),
              role: z.string().min(1),
              lag: z.string().min(0).optional(),
              storage: z.strictObject({
                mbBlocks: z.number().min(0),
                available: z.number().min(0),
                filesystem: z.string().min(1),
                mounted: z.string().min(1),
                type: z.string().min(1),
                unit: z.string().min(1),
                usedPercent: z.string().min(1),
                usedRaw: z.number().min(0),
              }),
            }),
          ),
        },
      },
    },
  },
} as const satisfies Endpoint;
